import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  $responsive?: string;
  $fitType?: 'cover' | 'contain' | 'adapt' | 'none';
}

export const Box = styled.div<IProps>`
  position: relative;
  overflow: hidden;
  min-width: 100%;
  min-height: 100%;
  background: #f6f6f6
    url('//static.wconcept.co.kr/display/images/onerror_img_product.png')
    no-repeat center / cover;

  .xgplayer {
    display: none;
    pointer-events: none;
  }

  &.is-poster-show {
    background: none;

    .area-poster {
      display: block;
    }
  }

  &.is-player-play {
    .xgplayer {
      display: block;
    }

    .area-poster {
      display: none;
    }
  }

  .xg-mobile-panel,
  .xgplayer-error,
  .xgplayer-loading,
  .xgplayer-enter,
  .xgplayer-unmute,
  .trigger,
  .xg-top-bar,
  .xgplayer-start,
  .xgplayer-replay {
    display: none !important;
  }

  .xgplayer-is-error {
    display: block !important;
    pointer-events: all !important;

    .xgplayer-error {
      display: block !important;
      opacity: 0;

      .xgplayer-error-button {
        width: 100% !important;
        height: 100% !important;
        position: absolute;
      }
    }
  }

  // 프로그래스바 기본 커스텀
  &.show-progress .xgplayer {
    .xgplayer-controls {
      transform: translateZ(0);
      visibility: visible;
      opacity: 1;
      height: auto;
      pointer-events: all;
    }

    //썸네일미리보기 공통
    .xgvideo-preview,
    .xgplayer-progress-btn,
    .xg-time-right,
    .xg-time-left,
    .xg-right-grid,
    .xg-left-grid {
      display: none !important;
    }

    // mo 버전(썸네일미리보기)
    .trigger {
      display: block !important;
      width: auto;
      height: auto;
      top: auto;
      left: 50%;
      transform: translateX(-50%);
      /* bottom: 30px; */
      bottom: calc(constant(safe-area-inset-bottom) + 30px);
      bottom: calc(env(safe-area-inset-bottom) + 30px);
      z-index: 2;
      opacity: 0;
      transition: opacity 0.2s;
      /* transition-delay: 0.2s; */

      &[data-xg-action='seeking'] {
        opacity: 1;
      }

      .time-preview .xg-seek-show .xg-dur,
      .time-preview .xg-seek-show .xg-separator,
      .time-preview .xg-seek-show .xg-seek-icon,
      .time-preview .xg-bar,
      .xg-playbackrate,
      .gradient {
        display: none;
      }

      .time-preview {
        padding: 0;
        top: auto;
        left: auto;
        transform: none;
        position: relative;
        overflow: hidden;
        text-shadow: none;

        /*  width: 86px;
        height: 152px;
        background: #f6f6f6
          url('//static.wconcept.co.kr/display/images/onerror_img_product.png')
          no-repeat center / cover;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 10px; */

        width: auto;

        .xg-seek-show {
          transform: none;
          width: 94px;
          height: 36px;
          line-height: 36px;
          border-radius: 100px;
          background: rgba(0, 0, 0, 0.5);

          .xg-cur {
            font-family: Pretendard;
            font-size: 16px;
            font-weight: 500;
            line-height: 130%;
            color: #fff !important;
            /* position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0; */
          }
        }

        .thumbnail {
          display: none !important;

          /* transform: scale(0.5375) translate(-50%);
          transform-origin: top left;

          &:before {
            content: '';
            display: block;
            width: 100%;
            height: 112px;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.6) 100%
            );
            position: absolute;
            bottom: 0;
            left: 0;
          } */
        }
      }
    }

    // pc 버전(썸네일미리보기)
    .xg-spot-info {
      position: fixed;
      bottom: 25px;
      left: 50%;
      transform: translate(-50%) !important;

      .xg-spot-line {
        bottom: 0;
        height: 26px;
        background-color: transparent;
      }

      .xgplayer-progress-point {
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
        text-align: center;
        color: #fff;
        font-family: Pretendard;
        font-size: 16px;
        font-weight: 500;
        line-height: 130%;
        width: 94px;
        height: 36px;
        padding: 8px 24px;
        border-radius: 100px;
        background: rgba(0, 0, 0, 0.5);
      }

      .xg-spot-thumbnail {
        .xg-spot-time {
          display: none !important;
        }

        .thumbnail {
          display: none !important;
        }
      }
    }

    // 프로그래스바 높이
    .xg-inner-controls .xgplayer-progress-outer,
    .xg-inner-controls {
      height: 2px;
    }

    .xg-inner-controls {
      left: auto;
      right: auto;
      bottom: 20px;
      width: 100%;
    }

    &.xgplayer-mobile .xg-center-grid,
    .xg-center-grid {
      padding: 0 20px;
      top: auto;
    }

    .xgplayer-progress {
      height: auto;
    }

    .xgplayer-progress-outer {
      border-radius: 0%;
    }

    .xgplayer-progress-cache {
      opacity: 0.3;
      background: #fff;
    }

    .xgplayer-progress-played {
      background-color: #fff;
    }
  }

  &.veVideo {
    .loading-icon,
    .refresh-icon,
    .pause-icon,
    .play-icon {
      position: absolute;
      top: 50% !important;
      left: 50% !important;
      transform: translateZ(0) translate(-50%, -50%) !important;
      z-index: 1;
      pointer-events: none;
      opacity: 0;

      &.loading-icon {
        opacity: 1;
      }
    }

    &.is-click-control {
      .refresh-icon,
      .pause-icon,
      .play-icon {
        opacity: 1;
      }
    }
  }

  border-radius: ${({ borderRadius }) =>
    typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius};

  ${props => {
    if (
      props.$responsive === 'true' &&
      typeof props.width === 'number' &&
      typeof props.height === 'number'
    ) {
      return css`
        .xgplayer {
          width: 100% !important;
          height: 100% !important;
          padding-bottom: ${(props.height / props.width) * 100}%;
        }
      `;
    }
    return css`
      width: ${typeof props.width === 'number'
        ? `${props.width}px`
        : props.width};
      height: ${typeof props.height === 'number'
        ? `${props.height}px`
        : props.height};
    `;
  }}

  ${props => {
    if (props.$fitType === 'none') {
      return css`
        min-width: auto;
        min-height: auto;

        .xgplayer {
          line-height: 0;
        }
      `;
    }
    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    &.show-progress {
      .xg-inner-controls {
        bottom: ${mixin.pxToVw('20')};
      }

      .xgplayer-mobile .xg-center-grid,
      .xg-center-grid {
        padding: ${mixin.pxToVw('0 20')};
      }

      .xgplayer-mobile .trigger {
        /* bottom: ${mixin.pxToVw('30')}; */
        bottom: calc(constant(safe-area-inset-bottom) + ${mixin.pxToVw('30')});
        bottom: calc(env(safe-area-inset-bottom) + ${mixin.pxToVw('30')});

        .time-preview {
          .xg-seek-show {
            width: ${mixin.pxToVw('94')};
            height: ${mixin.pxToVw('36')};
            line-height: ${mixin.pxToVw('35')};
            border-radius: ${mixin.pxToVw('100')};

            .xg-cur {
              font-size: ${mixin.pxToVw('16')};
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    &.show-progress {
      .xg-inner-controls {
        bottom: 40px;
      }

      .xgplayer-mobile .xg-center-grid,
      .xg-center-grid {
        top: 0;
      }
    }
  }
`;

export const Video = styled.div<IProps>`
  video {
    background-color: inherit;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: 0;
    object-fit: ${({ $fitType = 'cover' }) => $fitType};
  }

  ${props => {
    if (props.$fitType === 'none') {
      return css`
        video {
          position: relative;
          object-fit: initial;
        }
      `;
    }
    return null;
  }}
`;

export const Poster = styled.div<IProps>`
  transform: translateZ(0);
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  min-width: 100%;
  min-height: 100%;
  pointer-events: none;
  background-color: #000;

  .img {
    min-width: 100%;
    min-height: 100%;

    img {
      object-fit: ${({ $fitType = 'cover' }) => $fitType} !important;
    }
  }

  ${props => {
    if (props.$fitType === 'none') {
      return css`
        .img {
          img {
            position: relative !important;
            object-fit: contain !important;
          }
        }
      `;
    }
    return null;
  }}
`;
